import { createSlice } from '@reduxjs/toolkit'
import { SanctionFeesConfigById, SanctionFeesConfigList } from './thunk'
import _ from 'lodash'

export const feesConfigForm = {
    fee_id: '',
    fee_from: '',
    fee_to: '',
    fee_amount: ''
}
export const initialState = {
    data: [],
    form: feesConfigForm,
    loading: true
}
const SanctionFeesConfig = createSlice({
    name: 'SanctionFeesConfig',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        // Listing
        builder.addCase(SanctionFeesConfigList.pending, (state) => {
            state.loading = true
        })
        builder.addCase(SanctionFeesConfigList.fulfilled, (state, action) => {
            const { data } = action.payload
            state.form = feesConfigForm
            state.data = data
            state.loading = false
        })
        builder.addCase(SanctionFeesConfigList.rejected, (state) => {
            state.loading = false
        })

        builder.addCase(SanctionFeesConfigById.pending, (state) => {
            state.loading = true
        })
        builder.addCase(SanctionFeesConfigById.fulfilled, (state, action) => {
            const { payload } = action

            const data = _.pick(payload?.data, Object.keys(feesConfigForm))
            state.form = data
            state.loading = false
        })
        builder.addCase(SanctionFeesConfigById.rejected, (state) => {
            state.loading = false
        })
    }
})

// export const {} = SetupFee.actions
export default SanctionFeesConfig.reducer
